var _Path, _Path2, _Path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgTrash3(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M5.399 5.455l.91 14.554c.043.84.654 1.455 1.455 1.455h8.368c.804 0 1.404-.615 1.455-1.455l.91-14.554",
    stroke: "currentColor",
    strokeWidth: 0.97,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M3.943 5.455h16.01",
    stroke: "currentColor",
    strokeWidth: 0.97,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M9.037 5.455v-1.82a1.088 1.088 0 011.092-1.091h3.638a1.089 1.089 0 011.091 1.091v1.82M11.948 8.365v10.188M8.673 8.365l.364 10.188M15.222 8.365l-.364 10.188",
    stroke: "currentColor",
    strokeWidth: 0.97,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgTrash3;